// extracted by mini-css-extract-plugin
export default {"menu":"Header_menu__bKlxq","logo":"Header_logo__UsziS","navigation":"Header_navigation__HzEYB"};